import { useNavigate } from "react-router-dom";

/**
 * R5 — Single navigation helper for dashboard widgets.
 * Every clickable element in SR/SM dashboards routes through here.
 */
function useDashboardNavigation() {
  const navigate = useNavigate();

  const go = (filters = {}) => {
    navigate("/leads", { state: { filters } });
  };

  return {
    go,

    goOverdue: (extra = {}) =>
      go({ nextContact: "past_due", status: "all", ...extra }),

    goDueToday: (extra = {}) =>
      go({ nextContact: "due_next", status: "all", ...extra }),

    goDueThisWeek: (extra = {}) =>
      go({ nextContact: "upcoming", status: "all", ...extra }),

    goNoNext: (extra = {}) =>
      go({ noNext: 1, nextContact: "all", status: "all", ...extra }),

    goStale: (extra = {}) =>
      go({ stale: 1, staleDays: 60, status: "all", ...extra }),

    goByRep: (userId, extra = {}) =>
      go({ salesRep: String(userId), status: "all", ...extra }),

    goUnassigned: (extra = {}) =>
      go({ salesRep: "none", status: "all", ...extra }),

    goBySource: (source, extra = {}) =>
      go({ leadSource: source, status: "all", ...extra }),

    goByStatus: (status, extra = {}) =>
      go({ status, nextContact: "all", ...extra }),

    goRecentActivity: (extra = {}) =>
      go({ nextContact: "recent", status: "all", ...extra }),
  };
}

export default useDashboardNavigation;